var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"q-pl-md q-pr-md q-mt-xl text-grey"},[_vm._v("© Copyright "+_vm._s(_vm.moment().format('YYYY'))+" OzeIT.")])])}
var staticRenderFns = []

export { render, staticRenderFns }